<template>
  <div>
    <v-layout row wrap>
      <v-flex md6 lg4>
        <v-layout row>
          <v-flex align-self-center shrink>
            <v-icon large>calendar_today</v-icon>
          </v-flex>
          <v-flex grow>
            <v-menu
              ref="startDateMenu"
              v-model="startDateMenu"
              :nudge-right="40"
              :close-on-content-click="false"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="formatDate(startDate)"
                  label="Select Start Date"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md6 lg4>
        <v-layout row>
          <v-flex align-self-center shrink>
            <v-icon large>calendar_today</v-icon>
          </v-flex>
          <v-flex grow>
            <v-menu
              ref="endDateMenu"
              v-model="endDateMenu"
              :nudge-right="40"
              :close-on-content-click="false"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="formatDate(endDate)"
                  label="Select End Date"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="endDate"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs6 md4>
        <v-btn color="primary" @click="generate">Generate Report</v-btn>
      </v-flex>
    </v-layout>
    <v-divider light class="my-3"></v-divider>
    <v-layout row wrap class="mb-3">
      <v-flex>
        <h2 class="headline">Generated Reports</h2>
      </v-flex>
    </v-layout>
    <v-layout v-if="reports.length > 0" row wrap>
      <v-flex
        v-for="report in reports"
        :key="report.id"
        xs12
      >
        <v-chip
          outline
          class="subheading"
          :close="true"
          @input="deleteReport(report.id)"
        >
          <v-avatar>
            <v-icon>attach_file</v-icon>
          </v-avatar>
          <a target="new" @click.stop="generatePreviousReport(report)">
            {{ getReportName(report) }}
          </a>
        </v-chip>
      </v-flex>
    </v-layout>
    <v-layout v-else row wrap>
      <v-flex xs12>
        <v-alert :value="true" color="warning" icon="warning" outline>
          No previous reports were generated
        </v-alert>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'DetailsReport',
  data() {
    return {
      startDateMenu: false,
      endDateMenu: false,
      startDate: '',
      endDate: ''
    }
  },
  computed: {
    ...mapGetters({
      reports: 'HouseList/Reports/get',
      selectedHouse: 'HouseList/getSelectedHouse'
    })
  },
  methods: {
    ...mapActions({
      generateReport: 'HouseList/Reports/generate',
      deleteReport: 'HouseList/Reports/delete'
    }),
    generate() {
      this.generateReport({
        start: this.startDate,
        end: this.endDate
      })
    },
    generatePreviousReport(report) {
      this.generateReport({
        start: moment(report.start_date).format('YYYY-MM-DD'),
        end: moment(report.end_date).format('YYYY-MM-DD'),
      })
    },
    formatDate(date) {
      return date ? moment(date).format('DD MMMM YYYY') : ''
    },
    getReportName(report) {
      return this.selectedHouse.num + ' ' + this.selectedHouse.street + ' ' + moment(report.start_date).format('DDMMYYYY') + ' - ' + moment(report.end_date).format('DDMMYYYY') + '.pdf'
    }
  }
}
</script>
